import { useMutation } from '@apollo/client/react';
import { useResetAtom } from 'jotai/utils';
import { useCallback } from 'react';

import { FinishDraftAppointmentDocument } from '~/graphql/generated/graphql';
import { finishDraftAppointmentModalState } from '~/state/reception/atoms';

type Props = {
  draftAppointmentId: string;
};

export const useFinishDraftAppointment = (props: Props) => {
  const [finish, { error, loading }] = useMutation(FinishDraftAppointmentDocument);
  const resetModalState = useResetAtom(finishDraftAppointmentModalState);

  const handleFinish = useCallback(async () => {
    try {
      await finish({
        variables: {
          input: {
            draftAppointmentId: props.draftAppointmentId,
          },
        },
      });

      resetModalState();
    } catch {
      // 何もしない
    }
  }, [props.draftAppointmentId, finish, resetModalState]);

  return {
    loading,
    error,
    handleFinish,
  };
};
